import { Box, Chip } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import React from 'react'

const WorkerCancelTable = ({workerCancelList}) => {
  
  const columns = [
    { field: "displayIndex", headerName: "No", width: 90 },
    { field: "id", headerName: "ID", width: 70 },
    { field: "booking_business", headerName: "Franchisee Name", width: 180 },
    { field: "booking_service", headerName: "Booking Service", width: 200 },
    { field: "worker_name", headerName: "Worker Name", width: 170 },
    { field: "worker_phone", headerName: "Worker Phone", width: 140 },
    { field: "booking_user_phone", headerName: "Customer Phone", width: 140 },
    { field: "booking", headerName: "Booking Id", width: 100 },
    { field: "reason", headerName: "Reason", width: 200 },
    {
      field: "is_refund_processed",
      headerName: "Refund Processed",
      width: 200,
      renderCell: (params) => (
        <Chip
          label={params.value ? "Refunded" : "Not Refunded"}
          style={{
            backgroundColor: params.value ? "green" : "red",
            color: "white",
          }}
        />
      ),
    },]
  return (
    <>
     <Box
        sx={{
          flexGrow: 1,
          maxWidth: { xs: 650, sm: 682, lg: 1350 },
          bgcolor: "background.paper",
        }}
      >
        <DataGrid
          rows={workerCancelList}
          columns={columns}
          disableSelectionOnClick
          pageSizeOptions={[25, 50, 100]}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 25,
              },
            },
          }}
        />
      </Box>   
    </>
  )
}

export default WorkerCancelTable